import { Outlet, Link } from 'react-router'
import { Logo } from '#app/components/logo.tsx'

export default function AuthLayout() {
	return (
		<div className="flex min-h-svh flex-col items-center justify-center gap-6 bg-neutral-50 p-6 md:p-10">
			<div className="w-full max-w-sm text-center md:max-w-3xl">
				<div className="mb-6 flex justify-center">
					<Link to="/" className="flex items-center gap-2 font-medium">
						<div className="flex h-6 w-6 items-center justify-center rounded-md">
							<Logo className="h-full w-full" aria-hidden="true" />
						</div>
						Lydra AI
					</Link>
				</div>

				<div className="flex flex-col gap-6">
					<Outlet />
					<div className="text-muted-foreground hover:[&_a]:text-primary text-center text-xs text-balance [&_a]:underline [&_a]:underline-offset-4">
						By clicking continue, you agree to our{' '}
						<Link to="/terms-of-service">Terms of Service</Link> and{' '}
						<Link to="/privacy">Privacy Policy</Link>.
					</div>
				</div>
			</div>
		</div>
	)
}
